"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DXEncoding = void 0;
var map_creator_1 = require("../../../base-utils/map-creator");
var code_pages_1 = require("./code-pages");
var DXEncoding = (function () {
    function DXEncoding() {
    }
    DXEncoding.codePageFromCharset = function (charset) {
        var codePage = DXEncoding.charsetToCodepageMapping[charset];
        if (codePage)
            return codePage;
        return code_pages_1.CodePages.default;
    };
    DXEncoding.charsetToCodepageMapping = new map_creator_1.MapCreator()
        .add(0, code_pages_1.CodePages.Ansi)
        .add(134, code_pages_1.CodePages.GB2315)
        .add(129, code_pages_1.CodePages.Hangul)
        .add(136, code_pages_1.CodePages.Big5)
        .add(161, code_pages_1.CodePages.Greek)
        .add(162, code_pages_1.CodePages.Turkis)
        .add(163, code_pages_1.CodePages.Vietnamese)
        .add(177, code_pages_1.CodePages.Hebrew)
        .add(178, code_pages_1.CodePages.Arabic)
        .add(186, code_pages_1.CodePages.Baltic)
        .add(204, code_pages_1.CodePages.Russian)
        .add(238, code_pages_1.CodePages.default)
        .add(77, code_pages_1.CodePages.MacRoman)
        .add(89, code_pages_1.CodePages.MacRussian)
        .get();
    return DXEncoding;
}());
exports.DXEncoding = DXEncoding;
